import * as types from '../constants/actionTypes';

// http://redux.js.org/docs/advanced/AsyncActions.html
import fetch from 'isomorphic-fetch';

export function requestPrices() {
  return {
    type: types.REQUEST_PRICES
  };
}

export function receivePrices(json) {
  return {
    type: types.RECEIVE_PRICES,
    prices: json
  };
}

export function fetchPrices(from_city_id) {
  return dispatch => {
    dispatch(requestPrices());
    return fetch('https://s3.eu-central-1.amazonaws.com/climatelist-prices/' + from_city_id + '.json')
      .then(response => response.json())
      .then(json => dispatch(receivePrices(json)));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/pricesActions.js
 **/